import { faMinusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PropsWithChildren } from "react";
import styled from "styled-components";
import { NEAR_WHITE } from "../../../config";

const Container = styled.div<{ isLoading?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 12px;
  min-width: 50px;
  height: 36px;

  svg {
    cursor: pointer;
    transition: 0.2s ease;
    color: ${NEAR_WHITE};

    &:hover {
      color: ${NEAR_WHITE};
    }
  }
`;

interface ArrayControlProps {
  remove: (index: number) => void;
  fieldsLength: number;
  index: number;
  initialIndexAllowedToEdit?: number;
  allowEmpty?: boolean;
  readOnly?: boolean;
  isLoading?: boolean;
}

export function ArrayControl({
  fieldsLength,
  remove,
  index,
  initialIndexAllowedToEdit = 0,
  readOnly,
  allowEmpty,
  isLoading,
}: PropsWithChildren<ArrayControlProps>) {
  return (
    <Container isLoading={isLoading}>
      {!readOnly && (fieldsLength > 1 || allowEmpty) && index >= initialIndexAllowedToEdit ? (
        <div>
          <FontAwesomeIcon icon={faMinusCircle} onClick={() => remove(index)} />
        </div>
      ) : null}
    </Container>
  );
}

ArrayControl.defaultProps = {
  defaultValue: [],
  initialIndexAllowedToEdit: 0,
};
